import type {ShadowOrGlowOptionsObject} from '@Utils/fabric-shadow.util';
import {convertFabricShadowObjectToShadowOrGlowOptionsObject} from '@Utils/fabric-shadow.util';
import {useGetSelectedTranscriptItem} from '@Hooks/poster-editor/useGetSelectedTranscriptItem';
import {useGetKeyFromSubtitlePropertiesForTranscriptItem} from '@Hooks/poster-editor/useGetKeyFromSubtitlePropertiesForTranscriptItem';
import {useMemo} from 'react';

export function useGetShadowOptionsObjectForActiveTranscriptItem(): ShadowOrGlowOptionsObject | undefined | null {
  const activeTranscriptItem = useGetSelectedTranscriptItem();
  const transcriptItemShadow = useGetKeyFromSubtitlePropertiesForTranscriptItem('shadow');

  if (!activeTranscriptItem) {
    throw new Error('No active transcript item selected');
  }

  if (transcriptItemShadow === undefined) {
    throw new Error('transcript item does not have shadow property');
  }

  return useMemo(() => {
    return convertFabricShadowObjectToShadowOrGlowOptionsObject(transcriptItemShadow, activeTranscriptItem.getScaleForShadow());
  }, [transcriptItemShadow, activeTranscriptItem]);
}
